var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E488AF1C-63CE-4AEF-A1C9-EB84E8A18974") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-27.2714283%",
    x2: "50%",
    y2: "116.062986%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323232",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-1013.000000, -1376.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LineChart",
    transform: "translate(1013.000000, 1376.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-43-Copy-2",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.000000, 17.000000)",
    id: "Group-43-Copy"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 90,
    height: 70
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-42-Copy",
    transform: "translate(13.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(0.884956, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.222859294,49.8459887 L0.222859294,34.7256973 C8.65279403,26.9649855 7.58564081,11.6108133 12.7697614,10.6527048 C18.3032147,9.63003396 23.3590108,3.06751868 26.6983831,4.21902001 C33.0665447,6.41492566 31.3007698,16.7935403 40.1089142,23.7446654 C48.9170587,30.6957905 44.1444509,35.125 52.7729723,45.125 L52.7729723,49.8459887 L0.222859294,49.8459887 Z",
    id: "Line-3-Copy",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.1247588,
    y1: 0.125,
    x2: 0.1247588,
    y2: 49.875,
    id: "Line-4-Copy-13",
    stroke: "#C3C1C1",
    strokeWidth: 0.2,
    strokeLinecap: "square",
    strokeDasharray: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.2469226,
    y1: 49.875,
    x2: 0.1247588,
    y2: 49.875,
    id: "Line-4-Copy-14",
    stroke: "#C3C1C1",
    strokeWidth: 0.2,
    strokeLinecap: "square",
    strokeDasharray: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.2469226,
    y1: 38.375,
    x2: 0.1247588,
    y2: 38.375,
    id: "Line-4-Copy-15",
    stroke: "#C3C1C1",
    strokeWidth: 0.2,
    strokeLinecap: "square",
    strokeDasharray: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.2469226,
    y1: 26.875,
    x2: 0.1247588,
    y2: 26.875,
    id: "Line-4-Copy-16",
    stroke: "#C3C1C1",
    strokeWidth: 0.2,
    strokeLinecap: "square",
    strokeDasharray: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.2469226,
    y1: 15.375,
    x2: 0.1247588,
    y2: 15.375,
    id: "Line-4-Copy-17",
    stroke: "#C3C1C1",
    strokeWidth: 0.2,
    strokeLinecap: "square",
    strokeDasharray: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.2469226,
    y1: 3.875,
    x2: 0.1247588,
    y2: 3.875,
    id: "Line-4-Copy-18",
    stroke: "#C3C1C1",
    strokeWidth: 0.2,
    strokeLinecap: "square",
    strokeDasharray: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.3491916,
    y1: 0.125,
    x2: 13.3491916,
    y2: 49.875,
    id: "Line-4-Copy-19",
    stroke: "#C3C1C1",
    strokeWidth: 0.2,
    strokeLinecap: "square",
    strokeDasharray: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.5736243,
    y1: 0.125,
    x2: 26.5736243,
    y2: 49.875,
    id: "Line-4-Copy-20",
    stroke: "#C3C1C1",
    strokeWidth: 0.2,
    strokeLinecap: "square",
    strokeDasharray: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.7980571,
    y1: 0.125,
    x2: 39.7980571,
    y2: 49.875,
    id: "Line-4-Copy-21",
    stroke: "#C3C1C1",
    strokeWidth: 0.2,
    strokeLinecap: "square",
    strokeDasharray: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.0224899,
    y1: 0.125,
    x2: 53.0224899,
    y2: 49.875,
    id: "Line-4-Copy-22",
    stroke: "#C3C1C1",
    strokeWidth: 0.2,
    strokeLinecap: "square",
    strokeDasharray: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(0.000000, 3.097345)",
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-16",
    cx: 1.12740938,
    cy: 32.4159292,
    rx: 1.12740938,
    ry: 1.12642225
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-17",
    cx: 14.1552511,
    cy: 7.38432364,
    rx: 1.12740938,
    ry: 1.12642225
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-18",
    cx: 27.4336283,
    cy: 1.12642225,
    rx: 1.12740938,
    ry: 1.12642225
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-19",
    cx: 40.7120055,
    cy: 20.6510746,
    rx: 1.12740938,
    ry: 1.12642225
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-20",
    cx: 53.7398473,
    cy: 42.6788875,
    rx: 1.12740938,
    ry: 1.12642225
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChart);
export default __webpack_public_path__ + "static/media/LineChart.bf66fed8bf5b710a7b7e58ec46429dc7.svg";
export { ForwardRef as ReactComponent };